<template>
    <div class="img_source w710">
        <draggable
                class="perview_img"
                tag="ul"
                v-model="attachmentList"
                @start="isDragging=true"
                @end="draggEndSort"
        >
            <transition-group type="transition" :name="'flip-list'">
                <li v-for="(attachment,index) in attachmentList" :key="index">
                    <img :src="attachment.img" alt />
                    <div class="tips reset" @click="handleSetName(index)">{{attachment.disabled?'重命名':'完成'}}</div>
                    <div class="tips set" @click="handleSetCoverImg(index)">设为封面图</div>
                    <el-input class="tips whd-input-name" v-model="attachment.name" :disabled="attachment.disabled" placeholder="未命名图片" size="small"></el-input>
                    <i class="el-icon-circle-close delupload" @click="deletefile(index)"></i>
                </li>
            </transition-group>
        </draggable>
        <el-upload
                class="addicon"
                ref="imgupload"
                :data="uploaddata"
                :action="uploadurl"
                accept="image/jpeg,image/png"
                :on-success="handleSuccess"
                :on-error="handleError"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :file-list="fileList"
                multiple
        >
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
                <slot name="tipinfo"></slot>
            </div>
        </el-upload>
    </div>
</template>
<script>
    import api from "@/api.js";
    import draggable from "vuedraggable";
    export default {
        components: {
            draggable
        },
        props: ["picture"],
        data() {
            return {
                editable: true,
                isDragging: false,
                delayedDragging: false,
                uploadurl: api.uploadTokenImg,
                uploaddata: {token: sessionStorage.getItem("token")},
                fileList: this.picture || [],
                attachmentList: this.picture || [],
                input: ''
            };
        },
        watch: {
            isDragging(newValue) {
                if (newValue) {
                    this.delayedDragging = true;
                    return;
                }
                this.$nextTick(() => {
                    this.delayedDragging = false;
                });
            },
            picture(val) {
                this.attachmentList = this.initfilelist(val);
            }
        },
        created() {
            this.attachmentList = this.initfilelist(this.attachmentList);
        },
        methods: {
            draggEndSort() {
                this.uploadsucess();
                this.isDragging = false;
            },
            // 重命名
            handleSetName(index) {
                const item = this.attachmentList[index];
                item.disabled = !item.disabled;
                this.$set(this.attachmentList, index, item);
                if (item.disabled) {
                    this.uploadsucess();
                }
            },
            // 设为封面
            handleSetCoverImg(index) {
                this.$emit('onSetCoverImg', this.attachmentList[index].img);
            },
            // 初始化重组图像列表数据
            initfilelist(files) {
                let filelist = [];
                files.forEach((item, index) => {
                    item.disabled = true;
                    filelist.push(item);
                });
                return filelist;
            },
            // 上传成功
            handleSuccess(res, file) {
                if (res.code === 0) {
                    this.attachmentList.push({
                        img: res.path,
                        name: '',
                        disabled: true
                    });
                    this.uploadsucess();
                } else {
                    this.$message.error(res.msg);
                }
                this.loadingStatus.close();
            },
            uploadsucess() {
                const res = [];
                this.attachmentList.forEach(item => {
                    res.push(item);
                });
                this.$emit("uploadsucess", res);
            },
            // 获取重取图像列表数据
            getattachment(path) {
                let filelist = [];
                filelist.push();
                return filelist;
            },

            // 删除图像组件缓存数据
            deletefile(index) {
                this.attachmentList.splice(index, 1);
                this.fileList = this.attachmentList;
                this.uploadsucess();
            },
            handleError(err, file) {
                console.log(err)
                this.$message({
                    type: "error",
                    message: "上传失败"
                });
            },
            beforeUpload(file) {
                const isJPG = file.type === "image/jpeg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 10;
                let status = true;
                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG或者PNG 格式!");
                    status = false
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 10MB!");
                    status = false
                }
                if(status){
                  this.loadingStatus = this.$loading({
                    lock: true,
                    text: '上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)',
                    customClass: 'fontColor'
                  });
                }
                return isJPG && isLt2M;
            }
        }
    };
</script>

<style scoped>
.whd-form-item .perview_img, .addicon{display: inline-block;}
.whd-form-item .perview_img li, .addicon .avatar-uploader-icon{width: 148px; height: 148px; line-height: 148px;}
.tips{position: absolute; padding: 3px 8px; border-radius: 3px; background: rgba(0,0,0,.5); color: #fff; font-size: 12px; line-height: 1.4;}
.reset{left: 5px; top: 8px;}
.set{right: 5px; top: 8px;}
.whd-input-name{left: 0; bottom: -1px; right: 0; border-radius: 0; padding: 0;}
</style>
